import { browserTracingIntegration, init, replayIntegration } from '@sentry/react';
import { useLayoutStore } from '@/features/layout/store';
import { router } from '@/router/Router';
import { isLocalHost, isSandbox } from '@/std/url';
import { BREAKPOINTS } from './std/const/breakpoints';

function resize() {
    const isFullscreen =
        // @ts-expect-error - existe
        window.fullScreen ||
        (window.innerWidth === screen.width && window.innerHeight === screen.height);

    const hideLayout = Boolean(
        router.matchRoute({ to: '/a/pdv' }) || router.matchRoute({ to: '/a/separacao/monitor' }),
    );

    useLayoutStore.setState({
        hideLayout,
        isFullscreen,
        menuCollapsed: hideLayout || window.innerWidth <= BREAKPOINTS.xl,
        menuMobile: hideLayout || window.innerWidth < BREAKPOINTS.md,
    });
}

function registerEventsListeners(): void {
    window.addEventListener('resize', resize);

    window.addEventListener('vite:preloadError', () => {
        window.location.reload();
    });
}

const dsn =
    'https://45bfdaa1ee3b4784801e4cb13da79d16@o4507385320636416.ingest.us.sentry.io/4508298512105472';

function initSentry(): void {
    if (isLocalHost() || isSandbox()) {
        return;
    }

    init({
        dsn,
        environment: 'production',
        ignoreErrors: [
            // Script externo de preenchimento automático (execute_auto_fill).
            /^(?:ReferenceError: )?xbrowser is not defined$/,
            /Importing a module script failed/i,
            /undefined is not an object \(evaluating ['"]window\._META\.IABInnerFrame['"]\)/,
        ],
        integrations: [replayIntegration(), browserTracingIntegration()],
        replaysOnErrorSampleRate: 1.0,
        replaysSessionSampleRate: 0,
    });
}

export function initBeforeReact(): void {
    registerEventsListeners();
    resize();
    initSentry();
}
